import { NavLink } from "react-router-dom";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { useAuth } from "@/context/AuthContext";
import { useChatSocket } from "@/context/ChatSocket";
import { useChannels } from "@/hooks/useChat";
import { cn } from "@/lib/utils";
import { visibleNav } from "./navItems";

const linkClass = (collapsed) => ({ isActive }) =>
  cn(
    "group flex items-center gap-3 rounded-xl h-11 text-sm transition-colors duration-200",
    collapsed ? "justify-center px-0" : "px-3",
    isActive
      ? "bg-brand text-white shadow-sm shadow-brand/25"
      : "text-muted-foreground hover:bg-accent hover:text-foreground",
  );

const Badge = ({ count, collapsed }) => (count > 0 ? (
  <span className={cn("flex h-5 min-w-5 items-center justify-center rounded-full bg-brand-gold px-1.5 text-[11px] font-bold text-[#121014]", collapsed ? "absolute right-1.5 top-1" : "ml-auto")}
    data-testid="nav-chat-unread">{count > 99 ? "99+" : count}</span>
) : null);

export const NavList = ({ collapsed = false, onNavigate }) => {
  const { user } = useAuth();
  const { connected } = useChatSocket();
  const { data: channels = [] } = useChannels(!connected);
  const unread = channels.reduce((s, c) => s + c.unread, 0);
  return (
    <nav className="flex flex-col gap-1" data-testid="sidebar-nav">
      {visibleNav(user).map(({ key, label, path, icon: Icon }) => {
        const link = (
          <NavLink key={key} to={path} end={path === "/"} onClick={onNavigate} className={(s) => cn(linkClass(collapsed)(s), "relative")} data-testid={`nav-${key}`}>
            <Icon className="h-[18px] w-[18px] shrink-0" strokeWidth={1.8} />
            {!collapsed && <span className="truncate">{label}</span>}
            {key === "chat" && <Badge count={unread} collapsed={collapsed} />}
          </NavLink>
        );
        if (!collapsed) return link;
        return (
          <Tooltip key={key} delayDuration={100}>
            <TooltipTrigger asChild><span className="block">{link}</span></TooltipTrigger>
            <TooltipContent side="right">{label}</TooltipContent>
          </Tooltip>
        );
      })}
    </nav>
  );
};
